import { StorageService } from 'app/services/storage.service';
import { PhoneValidator } from './../../../directives/phone-validator.directive';
import { DriverLicenceModel } from 'app/models/dms/driverLicence.model';
import { LicenceScannerComponent } from './../licence-scanner/licence-scanner.component';
import { TabModel } from 'app/models/shared/tab.model';
import { ListItemModel } from 'app/models/shared/listItem.model';
import { GeneralService } from 'app/services/general.service';
import { FieldGroupModel } from 'app/models/shared/fieldGroup.model';


import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { FieldModel } from 'app/models/shared/field.model';
import { UserService } from 'app/services/user.service';
import { ContactService } from 'app/services/contact.service';
import { ContactType, ContactClass, SecurityRight, VehicleClass, LookupExternalCollection, ContactValidationSetting, OpportunityActivityType } from 'app/utility/enums';
import { ContactSearchParamsModel } from 'app/models/dms/contactSearchParams.model';
import { Constants } from 'app/utility/constants';
import { WizardPayloadModel } from 'app/models/wizard/wizardPayload.model';
import { Observable } from 'rxjs';
import { AlertController, IonSearchbar, LoadingController, ModalController, NavController, Platform } from '@ionic/angular';
import { ContactResultModel, ContactModel } from 'app/models/dms/contact.model';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ContactSearchResultModel } from 'app/models/dms/contactSearchResult.model';
import { SaleService } from 'app/services/sale.service';


@Component({
    selector: 'app-wizard-select-contact',
    templateUrl: './wizard-select-contact.component.html',
    styleUrls: ['./wizard-select-contact.component.scss'],
    standalone: false
})
export class WizardSelectContactComponent implements OnInit, OnDestroy
{

	@Input() contact: ContactResultModel;
	@Input() contactId: string;
	@Input() confirmContactChange: boolean = false;
	@Input() type: OpportunityActivityType;
	@Output() contactChange: EventEmitter<ContactResultModel> = new EventEmitter<ContactResultModel>();
	@Output() contactIdChange: EventEmitter<string> = new EventEmitter<string>();
	@Output() returnEvent: EventEmitter<WizardPayloadModel> = new EventEmitter<WizardPayloadModel>();
	@Input() navigation: Observable<WizardPayloadModel>;
	private navigationSubscription: any;

	private originalContact: ContactResultModel;

	showLoading: boolean = false;
	contactActive: boolean = false;
	canAdd: boolean = false;
	canEdit: boolean = false;

	contactInitials: string;

	isMobile: boolean = false;

	constructor(
		private alertController: AlertController,
		private contactService: ContactService,
		private userService: UserService,
		private generalService: GeneralService,
		private modalController: ModalController,
		private ref: ChangeDetectorRef,
		private storage: StorageService,
        private saleService: SaleService,
        private loadingController: LoadingController,
        public navCtrl: NavController,
	) { }

	ngOnInit()
	{
		this.navigationSubscription = this.navigation.subscribe(({ payload }) => this.navigationEvent(payload));

		this.initSearchParams();

		if (this.contact && this.contact.id != Constants.EmptyGuid)
		{
			if (this.contact)
			{
				this.contactActive = true;
				this.hasValidEmail = (this.contact.primaryEmail && this.validEmail(this.contact.primaryEmail));
				this.hasValidMobile = (this.contact.mobile && this.validPhone(this.contact.mobile));
				this.originalContact = Object.assign({}, this.contact);

                
                if (this.userService.mcMinVersion("3.2.23") &&
                    (this.type == OpportunityActivityType.FinanceApp || 
                    this.type == OpportunityActivityType.Sale))
                {
                    this.getExistingFinanceApp(this.contact);
                }
			}
		}
		if (!this.contactActive)
		{
			this.setSearchFocus();
		}

		this.initializeSearchSuggestions();

		this.canAdd = this.userService.hasUserRight(SecurityRight.ContactFunctionsCreate);
		this.canEdit = this.userService.hasAllRights([SecurityRight.ContactTabsAddressesEdit,SecurityRight.ContactTabsGeneralEdit]);

		this.loadCountriesLookup();
		this.loadCitiesLookup();
		this.initializeRecentContacts();
	}

	ngOnDestroy()
	{
		// console.log("Unsubscribing from navigation subscription");
		if (this.navigationSubscription) this.navigationSubscription.unsubscribe()
	}

	navigationEvent(payload: any)
	{

		this.showLoading = false;
		if (payload.direction == "back")
		{
			this.stepBack();
		}
	}

	public async stepBack()
	{
		//back to the search
		if (this.addContactForm)
		{
			this.addContactForm = false;
		}
		else if (this.editContactForm)
		{
			this.editContactForm = false;
		}
		else if (this.addContactMethod)
		{
			this.addContactMethod = false;
		}
		else if (this.addContact)
		{
			this.addContact = false;
		}
		//back if new customer selected (reset the customer to original before going back)
		else if (this.contact && this.contact != this.originalContact)
		{
			this.confirmContactChange = true;
			this.setContact(this.originalContact);
			this.contactActive = true;
			this.return("back");
		}
		//cancel select a different customer
		else if (!this.contact && this.originalContact)
		{
			this.confirmContactChange = true;
			this.setContact(this.originalContact);
			this.contactActive = true;
		}
		else
		{
			this.return("back");
		}
	}

	public async return(direction: string)
	{
		// console.log("return ", direction);

		this.returnEvent.emit(new WizardPayloadModel({ direction: direction, subpayload: new WizardPayloadModel(this.driverLicenceImage, "licenceImage") }));
	}

	public async changeContact(ev: any)
	{
		this.setContact(null);
	}

    public async preSetContact(contact: ContactResultModel = null)
    {
        this.setContact(contact);
        if (contact && this.userService.mcMinVersion("3.2.23") && (this.type == OpportunityActivityType.FinanceApp || this.type == OpportunityActivityType.Sale))
        {
            this.getExistingFinanceApp(contact);
        }
    }

	hasValidEmail: boolean = false;
	hasValidMobile: boolean = false;
	public async setContact(contact: ContactResultModel = null)
	{
		// console.log(contact);
		this.contact = Object.assign({}, contact);
		this.contactChange.emit(contact);
		if (contact)
		{
			// console.log(contact);
			this.contactId = (contact.id) ? contact.id : contact.contactId;
			this.contactIdChange.emit(this.contactId);
			this.saveRecentContact(contact);
			this.contactActive = true;

			this.hasValidEmail = (contact.primaryEmail && this.validEmail(contact.primaryEmail));
			this.hasValidMobile = (contact.mobile && this.validPhone(contact.mobile));
		}
		else
		{
			this.contactActive = false;
			this.setSearchFocus();
		}
	}

    async getExistingFinanceApp(contact: ContactResultModel)
    {
        const loading = await this.loadingController.create({
            message: 'Checking...',
            duration: 60000
        });
        await loading.present();

        this.saleService.getExistingFinanceApp(contact.id, Constants.EmptyGuid)
            .subscribe({next: async saleObject =>
            {
                await loading.dismiss();
                if (saleObject && saleObject.saleId && saleObject.saleId != Constants.EmptyGuid)
                {
                    const alert = await this.alertController.create({
                        header: "Existing finance application",
                        message: this.type == OpportunityActivityType.Sale ? 
                        "There is an active Avanti finance application for this customer. Would you like to attach it to this sale and use its details instead?" :
                        "There is an active Avanti finance application for this customer. Are you sure you want to start a new application?",
                        buttons: [
                            {
                                text: 'No',
                                role: 'No',
                                cssClass: 'primary',
                                handler: () =>
                                {
                                    if (this.type == OpportunityActivityType.Sale)
                                    {
                                        //do nothing, continue as normal
                                    }
                                    else
                                    {
                                        this.navCtrl.back();
                                    }
                                }
                            },
                            {
                                text: 'Yes',
                                cssClass: 'primary',
                                handler: () =>
                                {
                                    if (this.type == OpportunityActivityType.Sale)
                                    {
                                        if (saleObject.recordType == 'Sale')
                                        {
                                            this.navCtrl.navigateRoot('/sales/' + saleObject.saleId);
                                        }
                                        else
                                        {
                                            this.navCtrl.navigateRoot('/finance-application/' + saleObject.saleId + '?t=convert-to-sale');
                                        }
                                    }
                                    else
                                    {
                                        //do nothing, continue with new finance application
                                    }
                                }
                            }
                        ]
                    });
                    await alert.present();                        
                }
                else
                {
                    //no existing finance app found, continue as normal
                }
                
            }, error: async err =>
            {
                await loading.dismiss();
                this.handleError(err);
            }
        });
    }

	public async editContact(ev: any)
	{
		this.configureExistingContact(this.contactId);

	}
	editContactForm: boolean = false;

	//#region Searching

	searchQuery: string;
	searchActive: boolean = false;
	searchParams: ContactSearchParamsModel;
	searchSuggestionsIndex: string[];
	searchSuggestions: string[];
	@ViewChild('searchbar') searchbar: IonSearchbar;

	private async setSearchFocus()
	{
		setTimeout(() =>
		{
			this.searchbar.setFocus();
		}, 500);
	}



	async cancelSearch() { }
	async toggleSearch() { }

	initSearchParams()
	{
		this.searchParams = new ContactSearchParamsModel();
		this.searchParams.contactType = ContactType.Customer;
		this.searchParams.contactClass = ContactClass.All;
		this.searchParams.searchText = '';
		this.searchParams.pageNumber = 1;
		this.searchParams.pageSize = 12;
		this.searchParams.filterByAccountOwnerId = false;
	}

	initializeSearchSuggestions()
	{
		this.searchSuggestionsIndex = [];
		this.contactService.getCachedContactsIndex(this.searchParams.contactClass, this.searchParams.contactType, this.searchParams.filterByAccountOwnerId, this.searchParams.salesStatus)
			.subscribe(x =>
			{
				this.searchSuggestionsIndex = x;
			});
	}

	setSearchActive()
	{
		this.searchActive = true;
	}

	public getSearchSuggestions(ev: any)
	{
		// set val to the value of the searchbar
		const val = ev.target.value;
		this.searchActive = false;

		// if the value is an empty string don't filter the items
		if (val && val.trim() != '')
		{
			this.setSearchSuggestions(val);
		}
	}

	setSearchSuggestions(val: string)
	{
		var spaceIndex = val.indexOf(" ");
		var substr = val.substr(spaceIndex);
		if (val.length > 3 && spaceIndex > 0 && substr.length > 2)
		{
			this.searchSuggestions = this.searchSuggestionsIndex.filter((item) =>
			{
				return (item.toLowerCase().indexOf(val.toLowerCase()) == 0);
			}).slice(0, 5).concat((this.searchSuggestionsIndex.filter((item) =>
			{
				return (item.toLowerCase().indexOf(val.toLowerCase()) > 0);
			}).slice(0, 5)));
			// this.searchSuggestions.unshift("Search contacts for '"+val+"'");
		}
	}

	public clearSearchSuggestions()
	{
		this.searchQuery = '';
		this.searchSuggestions = [];
	}

	public setSearch(item)
	{
		setTimeout(() =>
		{
			this.searchQuery = item;
			this.runSearch();
		}, 50);
	}

	public doSearch(event: any)
	{
		setTimeout(() =>
		{
			if (event.target.value) {
				this.searchQuery = event.target.value.trim();
				this.runSearch();
			}
		}, 5);
		event.srcElement.blur();
	}

	public runSearch()
	{
		this.searchSuggestions = [];
		this.searchActive = true;

		//check if phone number
		var searchQuery = this.searchQuery;
		var phoneQuery: string = "";
		var phoneNumber = parsePhoneNumberFromString(searchQuery, "NZ");
		if (phoneNumber && phoneNumber.isValid())
		{
			phoneQuery = phoneNumber.formatInternational();
			searchQuery = phoneQuery.split(" ").join("").trim();
		}

		this.searchParams.searchText = searchQuery;
	}

	//#endregion

	//#region Add New Contact
	addContact: boolean = false;
	async addNewContact(ev: any)
	{
		// console.log("addNewContact", ev);
		this.queryString = ev;
		this.addContact = true;
	}

	public field_groups: FieldGroupModel[];
	public addcontactClass: ContactClass;
	public queryString: string;
	async addNewContactType(contactClass: ContactClass)
	{
		// console.log("addNewContactType", contactClass);
		this.addcontactClass = contactClass;

		if (contactClass == ContactClass.Business)
		{
			//go straight to the form
			this.configureNewContact(this.addcontactClass, this.queryString);
		}
		else
		{
			//see how they want to add the contact
			this.addContactMethod = true;
		}
		//   const loading = await this.loadingController.create({
		//     message: 'Saving'
		//   });
	}

	public addContactMethod: boolean = false;
	public contactCreateMethod: string;
	public async addNewContactMethod(method: "Licence" | "Manual" = "Manual")
	{
		// console.log("addNewContactMethod", method);
		this.contactCreateMethod = method;
		switch (method)
		{
			case "Licence":

				const modal = await this.modalController.create({
					component: LicenceScannerComponent,
					componentProps: {
						'title': 'Scan Driver Licence',
					}
				});
				this.driverLicenceImage = "";
				await modal.present();
				const { data } = await modal.onDidDismiss();

				if (data && data.relaunch) 
				{
					this.addNewContactMethod("Licence")
				}
				else if (data && data.data)
				{
					// console.log("Modal dismissed ", data);
					this.configureNewContact(this.addcontactClass, this.queryString, data.data);
					// this.setContact(data.contact);
				}
				break;
			case "Manual":
			default:
				this.configureNewContact(this.addcontactClass, this.queryString);
				break;
		}
	}

	create_contact_fields: TabModel;
	driverLicenceImage: string;
	public addContactForm: boolean = false;
	newContact: ContactModel;
	cityLoading: boolean = false;
	public configureNewContact(contactClass: ContactClass, queryString: string, driverLicenceData: DriverLicenceModel = null)
	{
		// console.log("configureNewContact", contactClass, queryString, driverLicenceData);
		this.addContactForm = false;
		this.showLoading = true;
		this.contactService
			.getContactTemplate(contactClass, ContactType.Customer)
			.subscribe({
				next: x =>
				{
					this.newContact = x;
					//this.launchContactEditor(create_contact_fields, (name != ''));

					var name = "";
					var email = "";
					var phone = "";
					var emailIndex = queryString.indexOf("@");
					const phoneNumber = parsePhoneNumberFromString(queryString, "NZ");

					if (phoneNumber && phoneNumber.isValid())
					{
						phone = phoneNumber.formatInternational();
					}
					else if (emailIndex > 0)
					{
						email = queryString;
					}
					else
					{
						name = queryString;
					}

					this.newContact.contactGeneral.name = name;
					this.newContact.contactGeneral.mobile = phone;
					this.newContact.contactGeneral.phone = phone;
					this.newContact.contactGeneral.primaryEmail = email;

					if (driverLicenceData)
					{
						this.driverLicenceImage = driverLicenceData.image;
						if (driverLicenceData.dob)
						{
							this.newContact.contactGeneral.dob = driverLicenceData.dob;
						}
						this.newContact.contactGeneral.firstName = driverLicenceData.first_names;
						this.newContact.contactGeneral.middleName = driverLicenceData.middle_names;
						this.newContact.contactGeneral.name = driverLicenceData.surname;
						this.newContact.contactGeneral.lastName = driverLicenceData.surname;
						this.newContact.contactGeneral.licenceNo = driverLicenceData.licence_no;
						this.newContact.contactGeneral.licenceVer = driverLicenceData.licence_version;
						this.newContact.contactGeneral.driverLicenseExpiry = driverLicenceData.licence_expiry;
						this.newContact.contactAddresses.physicalAddress1 = driverLicenceData.address;
						this.newContact.contactAddresses.physicalAddress2 = "";
						this.newContact.contactAddresses.physicalSuburb = driverLicenceData.suburb;
						this.newContact.contactAddresses.physicalPostCode = driverLicenceData.postcode;
						if (driverLicenceData.city)
						{
							this.cityLoading = true;
							this.generalService.findOrCreateExternalLookupCached(driverLicenceData.city, VehicleClass.All, LookupExternalCollection.LocationCity, Constants.EmptyGuid).subscribe(x =>
							{
								this.newContact.contactAddresses.physicalCity = x;
								this.newContact.contactAddresses.physicalCityId = x.id;

								this.cityLoading = false;

								this.tabs = this.getCreateContactFields(this.newContact, contactClass, ContactType.Customer, queryString);

								this.addContactForm = true;
								this.showLoading = false;
								this.loadCitiesLookup(true);
							})
						}
					}
					else
					{

						if (contactClass != ContactClass.Business)
						{
							var firstname = "";
							var lastname = "";
							if (name && name.length > 0)
							{
								var index = name.indexOf(" ");
								if (index > 0)
								{
									firstname = name.substr(0, index);
									lastname = name.slice(index).trim();
								}
								else
								{
									lastname = name;
								}
							}

							this.newContact.contactGeneral.firstName = firstname;
							this.newContact.contactGeneral.name = lastname;
						}
					}

					if (!this.cityLoading)
					{
						this.tabs = this.getCreateContactFields(this.newContact, contactClass, ContactType.Customer, queryString);

						this.addContactForm = true;
						this.showLoading = false;
					}

				},
				error: err =>
				{
					// console.log("ERROR: ", err);
					this.showLoading = false;
				}
			});
	}

	editContactModel: ContactModel;
	public configureExistingContact(contactId: string)
	{
		// console.log("configureExistingContact", contactId);
		this.addContactForm = false;
		this.editContactForm = false;
		this.showLoading = true;
		this.contactService
			.getContactById(contactId)
			.subscribe({
				next: x =>
				{
					this.newContact = x;

					if (!this.cityLoading)
					{
						this.tabs = this.getCreateContactFields(this.newContact, <ContactClass>x.contactClass, <ContactType>x.contactType, "");

						this.editContactForm = true;
						this.showLoading = false;
					}

				},
				error: err =>
				{
					// console.log("ERROR: ", err);
					this.showLoading = false;
				}
			});
	}

	private getCreateContactFields(contactTemplate: ContactModel, contactClass: ContactClass, contactType: ContactType, queryString: string = ""): TabModel[]
	{
		// console.log(contactTemplate, contactClass, contactType, queryString);
		var field_groups: FieldGroupModel[] = [];
		var field_groups2: FieldGroupModel[] = [];
		var group_1 = new FieldGroupModel("Add " + contactClass);

		if (this.canAdd||this.canEdit)
		{
			if (contactClass == ContactClass.Business)
			{
				var group_1 = new FieldGroupModel("Basic");
				group_1.addField(new FieldModel("Company name", contactTemplate.contactGeneral.name, "text", "name", true, true));
				group_1.addField(new FieldModel("Phone", contactTemplate.contactGeneral.phone, "tel", "phone"));
				group_1.addField(new FieldModel("Email address", contactTemplate.contactGeneral.primaryEmail, "email", "primaryEmail"));
				field_groups.push(group_1);
			}
			else
			{
				group_1.addField(new FieldModel("First name", contactTemplate.contactGeneral.firstName, "text", "firstName", true, false));
				if (contactTemplate.contactGeneral.middleName)
				{
					group_1.addField(new FieldModel("Middle name", contactTemplate.contactGeneral.middleName, "text", "middleName", true, true));
				}

				group_1.addField(new FieldModel("Last name", contactTemplate.contactGeneral.name, "text", "name", true, true));
				// group_1.addField(new FieldModel("Mobile", contactTemplate.contactGeneral.mobile, "tel", "mobile"));


				var mobRequired = (this.contactService.contactValidationSetting == ContactValidationSetting.AllMandatory || this.contactService.contactValidationSetting == ContactValidationSetting.MobilePhoneMandatory);
				var mobAssistiveText = "";
				switch (this.contactService.contactValidationSetting)
				{
					case ContactValidationSetting.AllOptional:
						mobAssistiveText = "";
						break;
					case ContactValidationSetting.EmailMandatory:
						mobAssistiveText = "You must enter an email address";
						break;
					case ContactValidationSetting.MobilePhoneMandatory:
						mobAssistiveText = "You must enter a phone number";
						break;
					case ContactValidationSetting.AllMandatory:
						mobAssistiveText = "You must enter a mobile number and email address";
						break;
					case ContactValidationSetting.AnyMandatory:
					default:
						mobAssistiveText = "You must enter either a mobile number or email address";
						break;
				}
				var emailRequired = (this.contactService.contactValidationSetting == ContactValidationSetting.AllMandatory || this.contactService.contactValidationSetting == ContactValidationSetting.EmailMandatory);


				var mob = new FieldModel("Mobile", contactTemplate.contactGeneral.mobile, "tel", "mobile", true, mobRequired);
				mob.assistiveText = mobAssistiveText;
				group_1.addField(mob);
				group_1.addField(new FieldModel("Email", contactTemplate.contactGeneral.primaryEmail, "email", "primaryEmail", true, emailRequired));
				field_groups.push(group_1);

				var group_2 = new FieldGroupModel("Driver license info");
				if (contactTemplate.contactGeneral.dob) {
					contactTemplate.contactGeneral.birthDate = new Date(contactTemplate.contactGeneral.dob);
					group_2.addField(new FieldModel("Date of birth", contactTemplate.contactGeneral.birthDate, "date", "birthDate"));
				}
				group_2.addField(new FieldModel("Driver licence number", contactTemplate.contactGeneral.licenceNo, "text", "licenceNo"));
				group_2.addField(new FieldModel("Driver licence version", contactTemplate.contactGeneral.licenceVer, "text", "licenceVer"));
				group_2.addField(new FieldModel("Driver licence expiry", contactTemplate.contactGeneral.driverLicenseExpiry, "date", "driverLicenseExpiry"));
				field_groups.push(group_2);
			}

			if (contactTemplate.contactAddresses)
			{
				let address_group = new FieldGroupModel("Physical Address");
				var physicalAddress1 = new FieldModel("Address Line 1", contactTemplate.contactAddresses.physicalAddress1, "autocomplete", "physicalAddress1", true, false, contactTemplate.contactAddresses);
				physicalAddress1.hasChildren = true;
				physicalAddress1.detailClass = "physical";
				address_group.addField(physicalAddress1);

				var physicalAddress2 = new FieldModel("Address Line 2", contactTemplate.contactAddresses.physicalAddress2, "text", "physicalAddress2");
				physicalAddress2.parent = 'physicalAddress1';
				address_group.addField(physicalAddress2);

				var physicalSuburb = new FieldModel("Suburb", contactTemplate.contactAddresses.physicalSuburb, "text", "physicalSuburb");
				physicalSuburb.parent = 'physicalAddress1';
				address_group.addField(physicalSuburb);

				var physicalCityId = new FieldModel("City", contactTemplate.contactAddresses.physicalCityId, "lookup", "physicalCityId", true, false, contactTemplate.contactAddresses.physicalCity);
				physicalCityId.parent = 'physicalAddress1';
				address_group.addField(physicalCityId);

				var postcode = new FieldModel("Postcode", contactTemplate.contactAddresses.physicalPostCode, "text", "physicalPostCode");
				postcode.parent = 'physicalAddress1';
				address_group.addField(postcode);
				field_groups2.push(address_group);
			}

		}

		var tabs: TabModel[] = []
		tabs.push(new TabModel("Contact Details", contactTemplate.contactGeneral, field_groups, true));
		if (contactTemplate.contactAddresses)
		{
			tabs.push(new TabModel("Address Details", contactTemplate.contactAddresses, field_groups2, true));
		}
		// else console.log(contactTemplate.contactAddresses);

		return tabs;
	}

	private getEditContactFields(contactTemplate: ContactModel): TabModel[]
	{
		// console.log("getEditContactFields", contactTemplate);
		var field_groups: FieldGroupModel[] = [];
		var field_groups2: FieldGroupModel[] = [];

		var group_1 = new FieldGroupModel("Basic");
		if (contactTemplate.contactClass == ContactClass.Business)
		{
			group_1.addField(new FieldModel("Company Name", contactTemplate.contactGeneral.name, "text", "name", true, true));
			group_1.addField(new FieldModel("Phone", contactTemplate.contactGeneral.phone, "tel", "phone"));
			group_1.addField(new FieldModel("Email Address", contactTemplate.contactGeneral.primaryEmail, "email", "primaryEmail"));
			field_groups.push(group_1);
		}
		else
		{
			group_1.addField(new FieldModel("First Name", contactTemplate.contactGeneral.firstName, "text", "firstName", true, true));
			if (contactTemplate.contactGeneral.middleName)
			{
				group_1.addField(new FieldModel("Middle Name", contactTemplate.contactGeneral.middleName, "text", "middleName", true, true));
			}

			group_1.addField(new FieldModel("Last Name", contactTemplate.contactGeneral.name, "text", "name", true, true));
			// group_1.addField(new FieldModel("Mobile", contactTemplate.contactGeneral.mobile, "tel", "mobile"));


			var mobRequired = (this.contactService.contactValidationSetting == ContactValidationSetting.AllMandatory || this.contactService.contactValidationSetting == ContactValidationSetting.MobilePhoneMandatory);
			var mobAssistiveText = "";
			switch (this.contactService.contactValidationSetting)
			{
				case ContactValidationSetting.AllOptional:
					mobAssistiveText = "";
					break;
				case ContactValidationSetting.EmailMandatory:
					mobAssistiveText = "You must enter an email address";
					break;
				case ContactValidationSetting.MobilePhoneMandatory:
					mobAssistiveText = "You must enter a phone number";
					break;
				case ContactValidationSetting.AllMandatory:
					mobAssistiveText = "You must enter a mobile number and email address";
					break;
				case ContactValidationSetting.AnyMandatory:
				default:
					mobAssistiveText = "You must enter either a mobile number or email address";
					break;
			}
			var emailRequired = (this.contactService.contactValidationSetting == ContactValidationSetting.AllMandatory || this.contactService.contactValidationSetting == ContactValidationSetting.EmailMandatory);


			var mob = new FieldModel("Mobile", contactTemplate.contactGeneral.mobile, "tel", "mobile");
			mob.assistiveText = mobAssistiveText;
			group_1.addField(mob);
			group_1.addField(new FieldModel("Email", contactTemplate.contactGeneral.primaryEmail, "email", "primaryEmail"));
			field_groups.push(group_1);
		}
		var tabs: TabModel[] = []
		tabs.push(new TabModel("Contact Details", contactTemplate.contactGeneral, field_groups, true));
		return tabs;
	}
	tabs: TabModel[];
	//#endregion

	// public countries: ListItemModel[];
	loadCountriesLookup()
	{
		// this.generalService.getCachedCountries().subscribe(x => { this.countries = x.map(y => new ListItemModel(y.countryId.toString(), y.name)); });
	}

	public cities: ListItemModel[];
	loadCitiesLookup(resetCache: boolean = false)
	{
		this.generalService.getCachedExternalLookups(VehicleClass.None, LookupExternalCollection.LocationCity, null, true).subscribe(x => { this.cities = x.map(y => new ListItemModel(y.id.toString(), y.caption)); });
	}

	saveNewContactForm()
	{
		if (!this.tabHasErrors())
		{
			this.create_contact_fields.syncFormWithObject();
			// console.log("We need to create the contact now...");
		}
	}

	saveActivated: boolean = false;
	private tabHasErrors()
	{
		this.saveActivated = true;
		if (this.create_contact_fields && this.create_contact_fields.errorCount > 0)
		{
			if (this.create_contact_fields.errorCount)
			{
				var message = "There " + (this.create_contact_fields.errorCount == 1 ? "is a field that needs" : "are " + this.create_contact_fields.errorCount + " fields that need ") + " correcting before you can proceed.";
				var title = (this.create_contact_fields.errorCount == 1) ? "Error Exists" : "Errors Exist";
				this.presentAlert(title, message);
				return true;
			}
		}
		return false;
	}


	async presentAlert(title: string, message: string)
	{
		this.userService.presentAlert(title, message);
	}

	public handleFieldClicked(ev: any)
	{
	}

	public handleFieldChanged(ev: any)
	{
		if (ev.detail && ev.detail.refresh)
		{
			setTimeout(() =>
			{
				this.ref.detectChanges();
			}, 500);
		}
		else
		{
			for (let field_group_tab of this.tabs)
			{
				field_group_tab.handleFieldChanged(ev);

				setTimeout(() =>
				{
					this.ref.detectChanges();
				}, 500);
			}

			this.handleFieldChangedAdditional(ev);
		}
	}

	async handleFieldChangedAdditional(ev: any)
	{
		this.contactService.handleFieldChangedForTabs(ev, this.tabs);
		this.ref.detectChanges();
	}

	showAllFieldsets: boolean = false;
	async displayAllFieldsets(ev: any)
	{
		this.showAllFieldsets = true;
	}

	savingContact: boolean = false;
	errorMessage: string = "";
	async saveContact(ev: any)
	{

		this.saveActivated = true;
		// if (this.savingContact) this.return; //double click prevention

		this.syncFormWithObject();

		this.errorMessage = "";

		var errorCount = this.errorFields();

		if (this.showAllFieldsets && errorCount > 0)
		{
			this.errorMessage = "There is an error on the form that needs correcting before you can continue. ";
			if (errorCount > 1)
			{
				this.errorMessage = "There are " + errorCount + " errors that need correcting before you can continue. ";
			}

		}

		var mobileField: FieldModel;
		var emailField: FieldModel;
		for (let tab of this.tabs)
		{
			for (let field_group of tab.fieldGroups)
			{
				for (let field of field_group.fields)
				{
					// console.log(field);
					if (field.id == "mobile" || field.id == "phone")
					{
						mobileField = field;
					}
					if (field.id == "primaryEmail")
					{
						emailField = field;
					}
				}
			}
		}

		if (!errorCount && !(emailField.value || mobileField.value))
		{
			// this.saveActivated = false;
			this.errorMessage = "Please enter either a mobile number or email address. ";

			this.cityLoading = true;
			mobileField.highlightAssistiveText = true;


			setTimeout(() =>
			{
				this.cityLoading = false;
			}, 100);
			errorCount++;

		}

		// // console.log(emailField.value, mobileField.value);
		// if (!errorCount && !(this.newContact.contactGeneral.primaryEmail || this.newContact.contactGeneral.mobile)) {
		// 	this.saveActivated = false;
		// 	this.errorMessage = "Please enter either a mobile number or email address. ";
		// }

		if (this.errorMessage)
		{
			const alert = await this.alertController.create({
				header: "Form Data Error",
				message: this.errorMessage,
				buttons: [
					{
						text: 'OK',
						role: 'cancel',
						cssClass: 'primary',
						handler: () =>
						{
							//do nothing
						}
					}
				]
			});
			await alert.present();
		}

		if (!errorCount)
		{
			this.savingContact = true;
			this.showLoading = true;
			this.contactService.saveContact(this.newContact).subscribe
				({
					next: x =>
					{
						// console.debug(x);
						var newContact = <unknown>x.contactSummary;

						this.setContact(<ContactResultModel>newContact);
						setTimeout(() =>
						{
							this.savingContact = false;
							this.showLoading = false;
							this.addContactForm = false;
							this.return("forward");
						}, 500);

					},
					error: err =>
					{
						this.savingContact = false;
						this.showLoading = false;
						this.handleError(err);
					}
				});
			}
	}


	public errorFields(): number
	{
		var errors: number = 0;
		for (let field_group_tab of this.tabs)
		{
			if (field_group_tab.errorCount)
			{
				// console.log("error exists in tab ", field_group_tab.label, field_group_tab.errorCount);
				errors += field_group_tab.errorCount;
			}
		}
		return errors;
	}


	public syncFormWithObject(): boolean
	{
		var data_changed = false;
		// console.log("syncformwithobject");
		for (let field_group_tab of this.tabs)
		{
			// console.log(field_group_tab);
			if (field_group_tab.dirty)
			{
				// console.log("tab is dirty");
				var tab_data_changed = field_group_tab.syncFormWithObject();
				data_changed = (data_changed || tab_data_changed);
				// console.log(field_group_tab);

			}
		}
		return data_changed;
	}
	public objectLoadError: boolean = false;
	public handleError(error: any): void
	{
		this.userService.handleError(error);
		this.objectLoadError = true;
	}

	public validEmail(email: string): boolean
	{
		var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		return re.test(String(email).toLowerCase());
	}

	public validPhone(phone: string): boolean
	{
		var phoneNumber = parsePhoneNumberFromString(phone, "NZ");
		if (phoneNumber && phoneNumber.isValid())
		{
			return true;
		}
	}


	saveRecentContact(contact: ContactResultModel)
	{
		this.storage.get(Constants.IonicStorage_SearchRecentContacts).then((val) =>
		{
			var recentContacts = JSON.parse(val);
			if (!recentContacts || !Array.isArray(recentContacts))
			{
				recentContacts = [];
			}
			else
			{
				recentContacts = recentContacts.filter(item => item.id !== contact.id); //remove contact if it is there already
			}

			recentContacts.unshift(contact);

			if (recentContacts.length > 30)
			{
				recentContacts = recentContacts.slice(0, 10);
			}
			// console.log(recentContacts);
			this.storage.set(Constants.IonicStorage_SearchRecentContacts, JSON.stringify(recentContacts));

		});
	}
	public initializeRecentContacts()
	{
		var tmpRecentContacts = [];
		this.storage.get(Constants.IonicStorage_SearchRecentContacts).then((val) =>
		{
			// console.log(val);
			var recentContactsObject = JSON.parse(val);

			if (recentContactsObject)
			{
				var itemcount = 0;
				recentContactsObject.forEach(function (item)
				{
					if (!item.id && item.contactId)
					{
						item.id = item.contactId;
					}
					if (item.id)
					{
						tmpRecentContacts.push(item);
					}
				});
				// console.log(this.recentContacts);
				this.recentContacts = tmpRecentContacts;

				// console.log(this.recentContacts);
			}
		});
	}
	recentContacts: ContactResultModel[];

	onBlur() {
		setTimeout(() => {
			if (this.searchQuery != this.searchParams.searchText) {
				this.searchQuery = this.searchParams.searchText;
			}
		}, 300);
	}

	existingContacts: ContactSearchResultModel;

	async findExistingContacts(ev: any) {
		this.saveActivated = true;
		// if (this.savingContact) this.return; //double click prevention

		this.syncFormWithObject();

		this.errorMessage = "";

		var errorCount = this.errorFields();

		if (this.showAllFieldsets && errorCount > 0)
		{
			this.errorMessage = "There is an error on the form that needs correcting before you can continue. ";
			if (errorCount > 1)
			{
				this.errorMessage = "There are " + errorCount + " errors that need correcting before you can continue. ";
			}

		}

		var mobileField: FieldModel;
		var emailField: FieldModel;
		for (let tab of this.tabs)
		{
			for (let field_group of tab.fieldGroups)
			{
				for (let field of field_group.fields)
				{
					// console.log(field);
					if (field.id == "mobile" || field.id == "phone")
					{
						mobileField = field;
					}
					if (field.id == "primaryEmail")
					{
						emailField = field;
					}
				}
			}
		}

		if (!errorCount && !(emailField.value || mobileField.value))
		{
			// this.saveActivated = false;
			this.errorMessage = "Please enter either a mobile number or email address. ";

			this.cityLoading = true;
			mobileField.highlightAssistiveText = true;


			setTimeout(() =>
			{
				this.cityLoading = false;
			}, 100);
			errorCount++;

		}

		if (this.errorMessage)
		{
			const alert = await this.alertController.create({
				header: "Form Data Error",
				message: this.errorMessage,
				buttons: [
					{
						text: 'OK',
						role: 'cancel',
						cssClass: 'primary',
						handler: () =>
						{
							//do nothing
						}
					}
				]
			});
			await alert.present();
		}

		if (!errorCount) {
			this.showLoading = true;

			var searchParams = new ContactSearchParamsModel();
			searchParams.contactType = ContactType.All;
			searchParams.contactClass = ContactClass.All;
			searchParams.pageNumber = 1;
			searchParams.pageSize = 9999;

			// Fire off two separate async searches
			searchParams.searchText = mobileField.value.toString();
			let mobileSearch$: Promise<ContactSearchResultModel> | null = null;
			if (searchParams.searchText != "") {
				mobileSearch$ = this.contactService.getContacts(searchParams).toPromise();
			}
			searchParams.searchText = emailField.value.toString();
			let emailSearch$: Promise<ContactSearchResultModel> | null = null;
			if (searchParams.searchText != "") {
				emailSearch$ = this.contactService.getContacts(searchParams).toPromise();
			}
			
		
			try {
				const results = await Promise.all([mobileSearch$, emailSearch$].filter(Boolean));
				
				const mobileMatches = results[0] || { contacts: [], resultCount: 0 };
				const emailMatches = results[1] || { contacts: [], resultCount: 0 };
				
				this.showLoading = false;

				var combinedResult = new ContactSearchResultModel();
				//combine without duplicates
				combinedResult.contacts = mobileMatches.contacts.concat(emailMatches.contacts).filter((item, index, self) =>
					self.findIndex((t) => (t.id === item.id)) === index
				);
				
				combinedResult.resultCount = mobileMatches.resultCount + emailMatches.resultCount;

				if (combinedResult.resultCount > 0) {
					this.addContactForm = false;
					this.editContactForm = false;
					this.addContactMethod = false;
					this.addContact = false;
					this.contactActive = false;
					this.existingContacts = combinedResult;
				} else {
					this.doSaveNewContact(ev); // No existing contacts found, proceed to save the new contact
				}
				
				// You can process the results as needed
			} catch (err) {
				this.showLoading = false;
				this.handleError(err);
			}
		}
	}

	public async setContactFromExisting(contactResult: ContactResultModel) {
		
		this.contactService.getContactById(contactResult.id)
			.subscribe({
				next: async contact =>
				{
					var message = "Are you sure you want to select this contact?"
					var buttons = [
						{
							text: 'Yes',
							handler: () =>
							{
								this.setContact(contactResult);
								setTimeout(() =>
								{
									this.addContactForm = false;
									this.addContactMethod = false;
									this.addContact = false;
									this.contactActive = true;
									this.editContactForm = false;
									this.existingContacts = null;
								}, 500);
							},
							role: '',
							cssClass: ''
						},
						{
							text: 'Cancel',
							role: 'cancel',
							cssClass: 'secondary',
							handler: () =>
							{
								//do nothing
							}				
						}
					]

					if (await this.hasDifferentContactInfo(contact))
					{
						message = "Are you sure you want to select this contact? This will replace the current contact.";
						buttons = [
							{
								text: 'Update details',
								handler: () =>
								{
									this.configureExistingContact(contactResult.id);
									this.setContact(contactResult);
									setTimeout(() =>
									{
										this.editContactForm = true;
										this.addContactForm = false;
										this.addContactMethod = false;
										this.addContact = false;
										this.contactActive = true;
										this.existingContacts = null;
									}, 500);
								},
								role: '',
								cssClass: ''
							},
							{
								text: 'Use existing',
								handler: () =>
								{
									this.setContact(contactResult);
									setTimeout(() =>
									{
										this.addContactForm = false;
										this.addContactMethod = false;
										this.addContact = false;
										this.contactActive = true;
										this.editContactForm = false;
										this.existingContacts = null;
									}, 500);

								},
								role: '',
								cssClass: ''
							},
							{
								text: 'Cancel',
								role: 'cancel',
								cssClass: 'secondary',
								handler: () =>
								{
									//do nothing
								}
							}
						];
					}
					//show an alert to confirm the change of contact
					var alert = await this.alertController.create({
						header: "Change Contact",
						message: message,
						buttons: buttons
					});

					await alert.present();
				},
				error: err =>
				{
					this.showLoading = false;
					this.handleError(err);
				}
			});	
	}

	previewContact(ev: any)
	{
		
	}

	doSaveNewContact(ev: any)
	{
		this.savingContact = true;
		this.showLoading = true;
		this.contactService.saveContact(this.newContact).subscribe
			({
				next: x =>
				{
					// console.debug(x);
					var newContact = <unknown>x.contactSummary;

					this.setContact(<ContactResultModel>newContact);
					setTimeout(() =>
					{
						this.savingContact = false;
						this.showLoading = false;
						this.addContactForm = false;
						this.addContactMethod = false;
						this.addContact = false;
						this.contactActive = true;
						this.editContactForm = false;
						this.existingContacts = null;
					}, 500);

				},
				error: err =>
				{
					this.savingContact = false;
					this.showLoading = false;
					this.handleError(err);
				}
			});
	}

	editCreateCustomer(ev: any)
	{
		this.existingContacts = null; 
		this.cityLoading = false; 
		this.addContactForm = true; 
		this.editContactForm = false; 
		this.addContactMethod = false; 
		this.addContact = true;
	}

	async hasDifferentContactInfo(populatedContact: ContactModel): Promise<boolean | void>
	{
		if (this.newContact.contactGeneral.firstName != populatedContact.contactGeneral.firstName ||
			this.newContact.contactGeneral.name != populatedContact.contactGeneral.name ||
			this.newContact.contactGeneral.mobile != populatedContact.contactGeneral.mobile ||
			this.newContact.contactGeneral.primaryEmail != populatedContact.contactGeneral.primaryEmail ||
			this.newContact.contactGeneral.licenceNo != populatedContact.contactGeneral.licenceNo ||
			this.newContact.contactGeneral.licenceVer != populatedContact.contactGeneral.licenceVer ||
			this.newContact.contactGeneral.driverLicenseExpiry != populatedContact.contactGeneral.driverLicenseExpiry ||
			this.newContact.contactAddresses.physicalAddress1 != populatedContact.contactAddresses.physicalAddress1 ||
			this.newContact.contactAddresses.physicalAddress2 != populatedContact.contactAddresses.physicalAddress2 ||
			this.newContact.contactAddresses.physicalSuburb != populatedContact.contactAddresses.physicalSuburb ||
			this.newContact.contactAddresses.physicalCityId != populatedContact.contactAddresses.physicalCityId ||
			this.newContact.contactAddresses.physicalPostCode != populatedContact.contactAddresses.physicalPostCode)
		{
			return true;
		}
		else
		{
			return false;
		}
	}

    public onKeypress(event: any)
	{
		if (event && event.key === 'Enter')
		{
			// console.log("searchItems", this.searchQuery);
			this.runSearch();
			event.srcElement.blur();
		}
	}
}
